import { i18nConfigure } from '@openx/utils/i18n/i18n.ts';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { App } from './App.tsx';
import { initialize as initializeEnvConfigs } from './environmentConfigs.ts';
import { initialize as initializeAnalyticsTools } from './modules/analytics/initialize.ts';

i18nConfigure();
initializeEnvConfigs();
initializeAnalyticsTools();

globalThis.__OPENX_VITE_ENV__ = import.meta.env;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
